module.exports = __webpack_public_path__ + "img/small-ball.5be460b5.svg";